import React, { useContext, useEffect, useState } from 'react';
import snakeCaseKeys from 'snakecase-keys';

import { HeaderFilter } from '../../../components';
import { IndexFiltersContext } from '../../../components/Shared';
import {
  indexInsuranceCategoryRequest,
  debounceIndexInsuranceCategoryRequest
} from '../../../requests/insuranceCategories';
import { advancedOptions, insuredLeadParams, tabOptions } from './InsuredLeadFilterParams';
import { insuranceSearchOptions } from '../../InsurancePolicy/Filters/InsurancePolicyFiltersParams';

const InsuredLeadFiltersHeader = ({ setMoreData }) => {
  const { customParamsRef } = useContext(IndexFiltersContext);
  const [customParams, setCustomParams] = useState(insuredLeadParams);

  const selectorOptions = [
    {
      fieldName: 'insuranceCategoryId',
      placeholder: 'Ramo',
      indexRequest: indexInsuranceCategoryRequest,
      debounceRequest: debounceIndexInsuranceCategoryRequest
    }
  ];

  const handleOnChangeParams = () => {
    customParamsRef.current = snakeCaseKeys(customParams);
    setMoreData(m => !m);
  };

  useEffect(handleOnChangeParams, [customParams]);

  return (
    <HeaderFilter
      paramName="quotationStatus"
      tabOptions={tabOptions}
      advancedOptions={advancedOptions}
      searchOptions={insuranceSearchOptions}
      remoteSelectors={selectorOptions}
      customParams={customParams}
      setCustomParams={setCustomParams}
    />
  );
};

export default InsuredLeadFiltersHeader;
